import { render, staticRenderFns } from "./Trainyudingshenqing.vue?vue&type=template&id=77bbde2d&scoped=true"
import script from "./Trainyudingshenqing.vue?vue&type=script&lang=js"
export * from "./Trainyudingshenqing.vue?vue&type=script&lang=js"
import style0 from "./Trainyudingshenqing.vue?vue&type=style&index=0&id=77bbde2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bbde2d",
  null
  
)

export default component.exports